import React, {useState, useEffect } from "react";

import { fetchDataViewStandBy } from './_redux/idcardsCrud';

import StandardNew from '../../components/standartComponents/standardNew'

/** Default system functions  */
import { getUserFactoryId, getUser } from '../../../index';
import api from '../../services/api';
import _ from 'lodash';

export default function IdcardNew(props) {
   
    const newstd = {
        name: '',
        productId: 0,
        defectCategoryId: 0,
        defectTypeId : 0,
        defectSource: '',
        description: '',
        consumerImpact: 'Menor',
        processImpact: 'Menor',
        occurrence: 'Remota',
        detection: 'Incerteza absoluta',
        eliminated: false,
        toolElimination: '',
        killerAction: '',
        eliminatedAt: null,
        reactivationReason: '',
        reactivationSource: '',
        reactivateAt: null,
        StructureId: null,
        standardType: "IDCARD",
        rpn: false,
        userId: getUser().id,
        status: 1,
        version: 1,
        steps: [],
        trainingUsers: [],
        epis: [],
        tools: [],
        lpps: [],
        images: []
    }

    //const products = await getProducts();

    var defaultDadosBasicos = [
                {
                    name: 'productId',
                    desc: 'Produto',
                    class: 'col-4',
                    options: 'selectasyncpaginate'
                },
                {
                    name: 'productTechnology',
                    desc: 'Tecnologia Associada ao Produto',
                    class: 'col-8',
                    // options: ['Defeito 01', 'Defeito 02']
                },
                {
                    name: 'defectCategoryId',
                    desc: 'Categoria do Defeito',
                    class: 'col-4',
                    options: []
                },  
                {
                    name: 'packingType',
                    desc: 'Tipo de Embalagem',
                    class: 'col-4',
                    reference: 'defectCategory.Embalagem'
                },
                {
                    name: 'packingTechnology',
                    desc: 'Tecnologia da Embalagem',
                    class: 'col-4',
                    reference: 'defectCategory.Embalagem'
                },
                {
                    name: 'defectTypeId',
                    desc: 'Tipo de Defeito',
                    class: 'col-4',
                    options: []
                },
                {
                    name: 'defectSource',
                    desc: 'Fonte do Modo de Defeito (onde ocorre)',
                    class: 'col-6',
                    // options: ['Defeito 01', 'Defeito 02']
                },     
                {
                    name: 'description',
                    desc: 'Descrição do Modo de Defeito',
                    class: 'col-12',
                    // options: ['Defeito 01', 'Defeito 02']
                },
                {
                    name: 'rpn',
                    desc: 'Linha não possui Matriz QA',
                    class: 'col-4',
                    // options: ['Defeito 01', 'Defeito 02']
                    options: 'checkbox'
                },                
                {
                    name: 'consumerImpact',
                    desc: 'Impacto para o consumidor',
                    class: 'col-4',
                    options: ['Menor', 'Moderado', 'Maior', 'Crítico'],
                    advanced: true
                },
                {
                    name: 'processImpact',
                    desc: 'Impacto para o processo',
                    class: 'col-4',
                    options: ['Menor', 'Moderado', 'Maior', 'Crítico'],
                    advanced: true
                },
                {
                    name: 'occurrence',
                    desc: 'Ocorrência',
                    class: 'col-4',
                    options: ['Remota', 'Baixa', 'Moderada', 'Alta', 'Muito Alta'],
                    advanced: true
                },
                {
                    name: 'detection',
                    desc: 'Detecção',
                    class: 'col-4',
                    options: ['Incerteza absoluta', 'Remota', 'Moderada', 'Alta', 'Certeza absoluta'],
                    advanced: true
                },
        ]

    useEffect(() => {
        requestDadosBasicos([
            { name: 'defectCategoryId', queryName: 'defectCategory' },
            { name: 'defectTypeId', queryName: 'defectType' },
        ]);

        function requestDadosBasicos(dados) {
            const newDadosBasicos = [...defaultDadosBasicos];
            dados.map(item => {
                api.get('/' + item.queryName + '/odata?$orderby=name asc&$filter=factoryId+eq+' + getUserFactoryId() + '&$select=id,name')
                    .then(response => {
                        var options = response.data.value.map(({
                            id: key,
                            name: value,
                            ...rest
                        }) => ({
                            key, value, ...rest
                        }))
                        const idx = defaultDadosBasicos.findIndex(i => i.name === item.name);
                        newDadosBasicos[idx].options = options;
                    });
            })
            defaultDadosBasicos = newDadosBasicos;
        }    
    }, [])
    
    return StandardNew(defaultDadosBasicos, props, newstd, fetchDataViewStandBy, 'idcard');
    
}
